<template>
  <div>
    <div
      class="flex items-center cursor-pointer whitespace-nowrap border border-dark ps-2 pe-1 gap-2 rounded-md h-6"
      @click="sortByPopover.toggle"
    >
      <span>
        {{ selectedLabel }}
      </span>
      <div>
        <WellIcon
          v-show="sortByPopover?.visible"
          icon="chevron-up"
          :size="18"
        />
        <WellIcon
          v-show="!sortByPopover?.visible"
          icon="chevron-down"
          :size="18"
        />
      </div>
    </div>
    <Popover
      ref="sortByPopover"
    >
      <div class="flex flex-col overflow-hidden rounded-md">
        <div
          class="flex items-center cursor-pointer px-4 py-1.5 hover:bg-dark hover:text-white"
          :class="{ 'bg-dark text-white': ordering === option.value }"
          v-for="option in orderingOptions"
          :key="option.value"
          @click="updateOrdering(option.value)"
        >
          {{ option.label }}
        </div>
      </div>
    </Popover>
  </div>
</template>

<script setup lang="ts">
import WellIcon from '@/components/common/WellIcon.vue'
import { ref } from 'vue'

const emit = defineEmits(['update:ordering'])

const props = defineProps({
  ordering: {
    type: String as PropType<OrderingType>,
    required: false,
    default: null
  },
  orderingOptions: {
    type: Array as PropType<OrderingOptions[]>,
    required: true
  }
})

const sortByPopover = ref(null)

const updateOrdering = (value: string) => {
  sortByPopover.value?.hide()
  emit('update:ordering', value)
}

const selectedLabel = computed(() => {
  const selectedOption = props.orderingOptions.find(option => option.value === props.ordering)
  return 'SORT BY' + (selectedOption ? `: ${selectedOption.selectedLabel}` : '')
})
</script>
